import script from "./VideoInstructionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoInstructionButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__